import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useUserProfile from "../../hooks/useUserProfile";

interface RequireProfileProps {
  adminOnly?: boolean;
  adminVistaFlowOnly?: boolean;
  supervisorOnly?: boolean;
}

const RequireProfile = ({
  adminOnly,
  adminVistaFlowOnly,
  supervisorOnly,
}: RequireProfileProps) => {
  const { auth } = useAuth();
  const location = useLocation();
  const { isAdmin, isAdminVistaflow, isDataEntrySupervisor, isUserLoading } =
    useUserProfile();

  if (!auth?.accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isUserLoading || isAdmin === null) {
    return null;
  }

  const hasAccess =
    (!adminVistaFlowOnly || isAdminVistaflow) &&
    (!adminOnly || isAdmin) &&
    (!supervisorOnly || isDataEntrySupervisor || isAdmin);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireProfile;
